import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  agency_id: undefined,
  fee_type: undefined,
  fee_value: undefined,
  id: null,
  identity_code: undefined,
  is_default: false,
  payment_method_id: undefined,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'fee_type' },
  { key: 'fee_value', validation: isValidPrice, invalidMessage: 'Invalid Value' },
  { key: 'payment_method_id' },
]

export default state
